var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"100px"}},[_c('Tableau',{ref:"tableau",attrs:{"url":"https://tableau.123goecom.com/javascripts/api/viz_v1.js","width:1000":"","height:1000":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }